<template>
  <div>
    <el-radio-group
      v-model="inputStyle.itemLayout"
      size="small"
      @change="itemLayoutChange"
    >
      <el-radio-button v-for="(item,index) in radioGroupList" :key="index" :label="item.label">
        {{item.title}}
      </el-radio-button>      
    </el-radio-group>
    <div v-if="inputStyle.itemLayout == 'box'" class="config_item">
      <FormTitle title="输入框控件线框颜色" />
      <Color key="box" v-model="inputStyle.inputItemBorderColor" quote-key="color" :is-quote="true" />
    </div>
    <div v-if="inputStyle.itemLayout == 'bottomLine'" class="config_item">
      <FormTitle title="输入框控件线框颜色" />
      <Color
        key="itemBottomLineColor"
        v-model="inputStyle.inputItemBottomLineColor"
        quote-key="color"
        :is-quote="true"
      />
    </div>
    <div v-if="inputStyle.itemLayout == 'gackground'" class="config_item">
      <FormTitle title="输入框控件底色" />
      <Color key="gackground" v-model="inputStyle.inputBackgroundColor" quote-key="color" :is-quote="true" />
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
// import SpRadioGroup from '@/weappTmps/comps/radioGroup/index.vue'
import Color from '@/weappTmps/comps/color/index.vue'
const radioGroupList = [{
  title:'线框',
  label:'box'
},{
  title:'底色',
  label:'gackground'
},{
  title:'下划线',
  label:'bottomLine'
},]
export default {
  name: 'FromInputType',
  mixins: [mixin],
  components: {
    Color
  },
  data() {
    return {
      inputStyle:{
        itemLayout: null,
        inputItemBorderColor:null,
        inputItemBottomLineColor:null,
        inputBackgroundColor:null,
      },
      radioGroupList,
    }
  },
  created () {
    console.log('FromInputType:created',this)
  },
  mounted(){
    console.log('FromInputType:mounted',this.inputStyle)
    this.init()
  },
  watch: {
    // itemLayout(nv,ov){
    //   this.itemLayoutChange()
    // }
  },
  methods: {
    init(){
      if(!this.inputStyle)
      this.inputStyle = {
        itemLayout: null,
        inputItemBorderColor:null,
        inputItemBottomLineColor:null,
        inputBackgroundColor:null,
      }
    },
    itemLayoutChange() {
      const Layout = this.inputStyle.itemLayout
      if (Layout == 'box') {
        this.$set(this.inputStyle, 'inputBackgroundColor', '')
        this.$set(this.inputStyle, 'inputItemBottomLineColor', '')
      }
      if (Layout == 'gackground') {
        this.$set(this.inputStyle, 'inputItemBorderColor', '')
        this.$set(this.inputStyle, 'inputItemBottomLineColor', '')
      }
      if (Layout == 'bottomLine') {
        this.$set(this.inputStyle, 'inputBackgroundColor', '')
        this.$set(this.inputStyle, 'inputItemBorderColor', '')
      }
      console.log('itemLayoutChange',this.inputStyle)
      this.$emit('input',this.inputStyle)
    }
  }
}
</script>
<style scoped lang="scss"></style>
